import { render } from "./PatientMessages.vue?vue&type=template&id=30f187f4"
import script from "./PatientMessages.vue?vue&type=script&lang=js"
export * from "./PatientMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__